import GastrofixSyncModal from "./modals/GastrofixSyncModal";
import Gastrofix from "./saga";

import { url as settingsUrl } from "app/Settings/config";
import { registerModals } from "modals";
import ShowImage from "app/App/modals/ShowImage";
import { registerRoutings } from "rootRouting";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const url = `${settingsUrl}/modules/Lightspeed`;
export const permissionKey = "module";

interface IConfig {
    permissions: {
        update: boolean;
    };
    routing: Array<string>;
    url: string;
}

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        permissions: {
            update: false,
        },
        routing: [],
        url,
    };

    if (!settings.modules.Gastrofix) {
        return config;
    }

    const modulePermissions = permissions.filter(
        (item) => item.indexOf(permissionKey) === 0
    );

    let routing: routingType = [];

    if (modulePermissions.indexOf(permissionKey + ".update") !== -1) {
        config.permissions.update = true;
        registerModals({ GastrofixSyncModal, ShowImage });
        store.injectSaga?.("Gastrofix", Gastrofix);

        routing.push({
            path: url,
            element: (
                <AsyncComponent
                    isModule={true}
                    path="Gastrofix/pages/GastrofixIndexPage"
                />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
